import {
  utils,
} from '@ama-sdk/core';
import {
  Journey,
  JourneyElementCommon,
} from '@dapi/sdk';
import {
  AcceptanceRepository,
  combineContacts,
  combineJourneys,
  combineJourneyTravelers,
  createCheckInFlightIdObject,
  createEligibility,
  createJourney,
  createJourneyElement,
  EligibilityRepository,
  EmailRepository,
  JourneyElementCommonRepository,
  JourneyTravelerRepository,
  MockJourney,
  MockJourneyTraveler,
  PhoneRepository,
  RecursivePartial,
} from '@dapi/sdk/spec';

export const travelers: MockJourneyTraveler[] = combineJourneyTravelers([JourneyTravelerRepository.DEFAULT, JourneyTravelerRepository.DEFAULT], {}).items;

export const travelerIds: string[] = travelers.filter(({id}) => !!id).map(({id}) => id);

export const journeyTemplate: RecursivePartial<Journey> = {
  contacts: combineContacts([EmailRepository.DEFAULT, PhoneRepository.DEFAULT], {
    travelerIds
  }).items,
  travelers
};

export const journeys: MockJourney[] = combineJourneys([
  {
    ...journeyTemplate,
    flights: [createCheckInFlightIdObject({
      template: {
        checkInFlight: {
          acceptanceStatus: 'notOpened'
        }
      }
    })],
    acceptanceEligibility: createEligibility({
      template: {
        status: 'ineligible',
        eligibilityWindow: {
          closingDateAndTime: new utils.DateTime(new utils.DateTime().getTime() + 24 * 3600 * 1000),
          openingDateAndTime: new utils.DateTime(new utils.DateTime().getTime() - 24 * 3600 * 1000)
        },
        reasons: ['regulatoryDetailsInhibition']
      }
    }),
    journeyElements: [
      {
        ...JourneyElementCommonRepository.DEFAULT,
        journeyElement: createJourneyElement({
          template: {
            acceptanceEligibility: createEligibility({
              template: {
                status: 'ineligible',
                reasons: ['regulatoryDetailsInhibition']
              }
            }),
            travelerId: 'JOURNEY-TRAVELER-1-MOCK'
          }
        })
      },
      {
        ...JourneyElementCommonRepository.DEFAULT,
        journeyElement: createJourneyElement({
          template: {
            acceptanceEligibility: createEligibility({
              template: {
                status: 'ineligible',
                reasons: ['regulatoryDetailsInhibition']
              }
            }),
            travelerId: 'JOURNEY-TRAVELER-2-MOCK'
          }
        })
      }
    ]
  }
]).items;

export const chosenJourney: MockJourney = journeys[0];

export const validRegulatoryJourneyFirstPax: MockJourney = createJourney({
  template: {
    ...chosenJourney,
    journeyElements: [
      {
        ...JourneyElementCommonRepository.DEFAULT,
        journeyElement: createJourneyElement({
          template: {
            acceptanceEligibility: EligibilityRepository.DEFAULT,
            travelerId: 'JOURNEY-TRAVELER-1-MOCK'
          }
        })
      },
      chosenJourney.journeyElements[1]
    ]
  }
});

export const validRegulatoryJourney: MockJourney = createJourney({
  template: {
    ...validRegulatoryJourneyFirstPax,
    journeyElements: [
      validRegulatoryJourneyFirstPax.journeyElements[0],
      {
        ...JourneyElementCommonRepository.DEFAULT,
        journeyElement: createJourneyElement({
          template: {
            acceptanceEligibility: EligibilityRepository.DEFAULT,
            travelerId: 'JOURNEY-TRAVELER-2-MOCK'
          }
        })
      }
    ]
  }
});

export const acceptedChosenJourney: MockJourney = createJourney({
  template: {
    ...validRegulatoryJourney,
    acceptance: AcceptanceRepository.ACCEPTED
  }
});

export const journeyElementIds: string[] = chosenJourney.journeyElements.map((je: JourneyElementCommon) => je.id);
